export const IPFS_MODE = process.env.REACT_APP_IPFS_MODE === 'true';
export const RATES_HISTORY_ENDPOINT = process.env.REACT_APP_RATES_HISTORY_ENDPOINT;
